'use strict';
angular.module('schoolLinqApp').directive('fixedWidthReader', function () {
	return {
		scope: {
			fixedWidthReader: '=',
			readerType: '@',
			filename: '=',
		},
		link: function (scope, element) {
			$(element).on('change', function (changeEvent) {
				var files = changeEvent.target.files;
				if (files.length) {
					var r = new FileReader();
					if (files[0]) {
						scope.filename = files[0].name;
					}
					r.onload = function (e) {
						var values = [];
						var csvFile = e.target.result;
						var lines = csvFile.split('\n');
						var start = 1; // don't process the header line
						if (scope.readerType === 'orbit') {
							// the orbit file has no header line
							start = 0;
						}
						for (var i = start; i < lines.length; i++) {
							var data = lines[i];
							if (data && data.length > 0) {
								if (scope.readerType === 'orbit') {
									if (i === start) {
										values.push({
											RecordIndicator: data.substring(0, 1),
											AgencyNumber: data.substring(1, 6),
										});
									} else {
										values.push({
											RecordIndicator: data.substring(0, 1),
											SSN: data.substring(6, 15),
											RetirementNumber: data.substring(15, 24),
											FirstName: data.substring(24, 74).trim(),
											MiddleName: data.substring(74, 124).trim(),
											LastName: data.substring(124, 174).trim(),
										});
									}
								}
							}
						}

						scope.$apply(function () {
							scope.fixedWidthReader = values;
						});
					};

					r.readAsText(files[0]);
				}
			});
		},
	};
});
